module.exports = ""


//////////////////
// WEBPACK FOOTER
// D:/Finca/Finca UI/UI/src/app/auth/logout/logout.component.html
// module id = ../../../../../src/app/auth/logout/logout.component.html
// module chunks = main